const DAY = 24 * 60 * 60 * 1000;
// Monday through Friday; no holiday calendar or office-hour schedule configured.
export function elapsedBusinessDays(start, end) {
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return 0;
  // Odoo timestamps and the existing delay calculation use UTC.
  let cursor = start;
  const finish = end;
  let elapsed = 0;
  while (cursor < finish) {
    const nextDay = (Math.floor(cursor / DAY) + 1) * DAY;
    const boundary = Math.min(nextDay, finish);
    const weekday = new Date(cursor).getUTCDay();
    if (weekday !== 0 && weekday !== 6) elapsed += boundary - cursor;
    cursor = boundary;
  }
  return elapsed / DAY;
}
